var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80775 19.5C4.30258 19.5 3.875 19.325 3.525 18.975C3.175 18.625 3 18.1974 3 17.6923V6.30775C3 5.80258 3.175 5.375 3.525 5.025C3.875 4.675 4.30258 4.5 4.80775 4.5H20.1923C20.6974 4.5 21.125 4.675 21.475 5.025C21.825 5.375 22 5.80258 22 6.30775V17.6923C22 18.1974 21.825 18.625 21.475 18.975C21.125 19.325 20.6974 19.5 20.1923 19.5H4.80775ZM12.5 12.5577L4.5 7.44225V17.6923C4.5 17.7821 4.52883 17.8558 4.5865 17.9135C4.64417 17.9712 4.71792 18 4.80775 18H20.1923C20.2821 18 20.3558 17.9712 20.4135 17.9135C20.4712 17.8558 20.5 17.7821 20.5 17.6923V7.44225L12.5 12.5577ZM12.5 11L20.3463 6H4.65375L12.5 11ZM4.5 7.44225V6V17.6923C4.5 17.7821 4.52883 17.8558 4.5865 17.9135C4.64417 17.9712 4.71792 18 4.80775 18H4.5V7.44225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/email-logo.2f8cf92db6d49dfb02af370e4d44181d.svg";
export { ForwardRef as ReactComponent };